import { QuestionOptionV3 } from '../models/dynamic-form-v3.models';
import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class CheckboxQuestionV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.CHECKBOX;
  options: QuestionOptionV3[];
  color: string;

  constructor(options: any = {}) {
    super(options);
    this.color = options['color'] || 'primary';
    this.options = options['options'] || [];
  }
}
